import { Button, Grid, TextField, Typography } from '@mui/material';
import { FormikValues } from 'formik';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';
import { FIELD_ID, FIELD_REASON } from './appeals-decline-schema';
import { useAppealsDecline } from './useAppealsDecline';

interface AppealsDeclineDialogProps {
  title?: string;
  text?: string;
  id: string | number;
  popDialog?: any;
  onSubmit: (values: FormikValues) => void;
}

export const AppealsDeclineDialog: ComponentType<AppealsDeclineDialogProps> = ({
  title: dialogTitle,
  text,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const { formik, handleFieldChange, hasError, getErrorMessage } = useAppealsDecline({ onSubmit });

  const title = dialogTitle ? dialogTitle : t('appeal.decline.title', 'Отклонить апелляцию');

  useEffect(() => {
    formik.setFieldValue(FIELD_ID, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BaseDialog {...{ ...props, popDialog, title }}>
      {text && (
        <Typography variant="h5" component="p" mb={2}>
          {text}
        </Typography>
      )}
      <form onSubmit={formik.handleSubmit}>
        <Grid container mb={4} direction="column" spacing={1}>
          <Grid item>
            <TextField
              {...formik.getFieldProps(FIELD_REASON)}
              onChange={(e: any) => handleFieldChange(FIELD_REASON, e)}
              error={hasError(FIELD_REASON)}
              helperText={getErrorMessage(FIELD_REASON)}
              label={t('appeal.decline.reason.label', 'Причина отказа в апелляции')}
              placeholder={t('appeal.decline.explanation.placeholder', 'Введите причину...')}
              fullWidth
              multiline
              rows={4}
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={2} justifyContent="flex-end">
          <Grid item xs={6}>
            <Button
              onClick={popDialog}
              variant="outlined"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('cancel', 'Отмена')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="error"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('action.decline', 'Отклонить')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </BaseDialog>
  );
};
